import {Injectable} from '@angular/core';
import {OttVoucherApi} from '../../api/ott-voucher/ott-voucher.api.class';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OttVoucherService {

  constructor(private ottVoucherApi: OttVoucherApi) { }

  initiateTransaction(voucherNumber: string, mobileNumber: string): Observable<any> {
    return this.ottVoucherApi.initiateVoucherTransaction(voucherNumber, mobileNumber, sessionStorage.getItem('sessionToken'));
  }

  redeemVoucher(voucherNumber: string, mobileNumber: string): Observable<any> {
    return this.ottVoucherApi.redeemVoucher(voucherNumber, mobileNumber, sessionStorage.getItem('sessionToken'), sessionStorage.getItem('ott-voucher-transactionId'));
  }
}
